import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import ChildServiceLayout from '../components/ChildServiceLayout';
import AudioEngineer2 from '../assets/Services/AudioEngineer_2.png';

const AudioEngineerPage = () => {
  return (
    <>
      <Helmet>
        <title>Mixing & Mastering Services | Westchester Studio</title>
        <meta
          name="description"
          content="Professional audio engineering for artists in Westchester County. Serving New Rochelle, Pelham, and surrounding areas."
        />
      </Helmet>

      <ChildServiceLayout
        title="Professional Audio Engineering"
        intro="Ensure your live performance or studio session sounds flawless and professional with our skilled audio engineers."
        image={AudioEngineer2}
        cta={{
          heading: 'Book an Audio Engineer',
          text: 'Let us handle your sound so you can focus on your performance.',
          link: { href: '/contact', text: 'Get a Quote' },
        }}
      >
        <h2>What We Offer</h2>
        <ul>
          <li><strong>Live Sound Engineering</strong> – Mixing and managing sound at gigs, events, and venues</li>
          <li><strong>Studio Recording</strong> – Capturing high-quality audio in a professional setting</li>
          <li><strong>On-Site Mobile Recording</strong> – Bringing the studio experience to your space</li>
          <li><strong>Sound System Optimization</strong> – Ensuring balanced, clear, and powerful audio</li>
          <li><strong>Custom Audio Solutions</strong> – Tailored to your event’s specific needs</li>
        </ul>
        <p>
          Looking for <strong>top-tier sound quality</strong>? Pair our engineer services with our
          <Link to="/services/live-sound/gear-rental"> Gear Rental</Link> options for a complete audio experience.
        </p>
      </ChildServiceLayout>
    </>
  );
};

export default AudioEngineerPage;
